// Module
var code = "<div class=\"dms-content-standard\">\r\n    <div class=\"dms-content-wrapper\">\r\n        <div class=\"dms-content-header\"></div>\r\n        <div class=\"dms-content-container\"></div>\r\n    </div>\r\n</div>\r\n";
// Exports
export default code;